
import MenuItem from './MenuItem.vue'

export default {
  components: {
    MenuItem,
  },
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    headerHeight: {
      type: Number,
      default: 0,
    },
    current: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeItem: this.current,
    }
  },
  methods: {
    isActive(item) {
      return item.id === this.activeItem
    },
    handleClick(item) {
      this.activeItem = item.id
    },
  },
}
